const tlMessages = {
  /* 01.General */
  "chat.end": "I-restart ang iyong pag-uusap sa chat",
  "chat.endall": "Tapusin ang Chat",
  "chat.cancel": "Kanselahin",
  "chat.cookie":
    "Gumagamit ang cookies ng digital na ito ng cookies upang matiyak na makukuha mo ang pinakamahusay na karanasan",
  "chat.learn": "Matuto nang higit pa",
  "chat.minimize": "I-minimize",
  "chat.hide": "Isara",
  "chat.hidebot.text":
    "Ang pagsara ay gagawing mawala ang avatar sa loob ng 15 minuto",
  "chat.hidebot": "Isara ang Bot",
  "chat.restart": "I-restart",
  "switch.language": "Lumipat ng Wika",
  "switch.property": "Lumipat ng Ari-arian",
  "restart.converstation": "I-restart ang Conversation",
  "chat.endtext": "Sigurado ka bang gusto mong tapusin ang kasalukuyang chat?",
  "check.availabity": "Suriin ang Availability",
  "check.availabity.submit": "Ipasa",
  "check.availabity.cancel": "Kanselahin",
  "check.availabity.adults": "Matanda ",
  "check.availabity.children": "Mga bata",
  "check.availabity.child.age": "Edad - Bata",
  "feedback.leave": "Mag-iwan ng opinyon",
  "feedback.leave.message": "Mag-iwan ng mensahe",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Isumite ang Kaso",
  "caseform.system": "Sistema",
  "caseform.loading.systems": "Naglo-load ng mga sistema...",
  "caseform.select.system": "Piliin ang Sistema",
  "caseform.error.systems": "Error sa paglo-load ng mga sistema",
  "caseform.scenario": "Senaryo",
  "caseform.loading.scenarios": "Naglo-load ng mga senaryo...",
  "caseform.select.scenario": "Piliin ang Senaryo",
  "caseform.error.scenarios": "Error sa paglo-load ng mga senaryo",
  "caseform.topic": "Paksa",
  "caseform.loading.topics": "Naglo-load ng mga paksa...",
  "caseform.select.topic": "Piliin ang Paksa",
  "caseform.error.topics": "Error sa paglo-load ng mga paksa",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "Paksa",
  "caseform.description": "Paglalarawan",
  "caseform.attachments": "Mga Kalakip",
  "caseform.attachments.remove": "Alisin",
  "caseform.submit": "Isumite",
  "caseform.cancel": "Kanselahin",
  "caseform.success.title": "Nagawa ang Kaso",
  "caseform.success.message": "Matagumpay na nagawa ang iyong kaso.",
  "caseform.success.caseNumber": "Numero ng Kaso:",
  "caseform.success.transferToLiveAgent": "Inililipat ka na sa live agent.",
  "caseform.success.newChatWindowRightSide":
    "Magbubukas ang bagong chat window sa kanang bahagi ng iyong browser.",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Piliin ang Aksyon",
  "simpleaction.body":
    "Mangyaring piliin ang isa sa mga sumusunod na opsyon:{br}{b}Gumawa ng Kaso{/b} upang mag-submit ng support request, o {b}Magsimula ng Chat{/b} upang kumonekta sa isang ahente ngayon.",
  "simpleaction.startchat": "Magsimula ng Chat",
  "simpleaction.createcase": "Gumawa ng Kaso",
  "caseform.error.generic": "Error sa paggawa ng kaso.",
  "caseform.error.generic.message":
    "Nagkaroon ng error habang ginagawa ang iyong kaso. Mangyaring subukan muli mamaya.",
};
export default tlMessages;
